import { Link, useLocation } from "react-router-dom";
import { Home, Trophy, Users, UserCircle } from "lucide-react";
import { useSelector } from "react-redux";

const BottomNavBar = () => {
  const location = useLocation();
  // Redux
  const user = useSelector((state) => state.user.user);
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);

  return (
    <div className="fixed bottom-0 left-0 right-0 h-20 bg-white/95 backdrop-blur-lg border-t border-gray-200 flex justify-around items-center z-50">
      <NavItem
        to="/"
        label="Inicio"
        icon={<Home size={24} />}
        isActive={location.pathname === "/"}
      />
      <NavItem
        to="/tournaments"
        label="Torneos"
        icon={<Trophy size={24} />}
        isActive={location.pathname.startsWith("/tournaments")}
      />
      <NavItem
        to="/teams"
        label="Equipos"
        icon={<Users size={24} />}
        isActive={location.pathname.startsWith("/teams")}
      />
      <NavItem
        to="/profile"
        label="Perfil"
        icon={
          isLoggedIn && user?.profile_picture_url ? (
            <div className="w-8 h-8 rounded-full overflow-hidden flex items-center justify-center bg-gray-200">
              <img
                src={user.profile_picture_url}
                alt="Perfil"
                className="w-full h-full object-cover"
              />
            </div>
          ) : (
            <UserCircle size={24} />
          )
        }
        isActive={location.pathname.startsWith("/profile")}
      />
    </div>
  );
};

const NavItem = ({ to, label, icon, isActive }) => (
  <Link
    to={to}
    className={`flex flex-col items-center transition-colors ${
      isActive
        ? "text-emerald-500 font-bold"
        : "text-gray-500 hover:text-emerald-500"
    }`}
  >
    {icon}
    <span className="text-xs mt-1">{label}</span>
  </Link>
);

export default BottomNavBar;
